import AbstractMapper from '@core/utils/mappers/AbstractMapper';

import ILottoFavouritesDto, { ILottoFavouritesDtoRaw } from '@core/mappers/lotto/dtos/ILottoFavouritesDto';
import Logger from '@core/utils/loggers/Logger';

export type Favourites = Record<string, number[][]>;

/*
    LottoFavourites are in format
    [{ "k": "number", "v": ["...number", "...number"] }]
    but the object is stringified one extra time so all '"' prefixed with '\'
    ex. [{\"k\":\"6\",\"v\":[\"2,10,17,27,30,56,60\",\"3,4,18\"]},{\"k\":\"83\",\"v\":[\"24,44,56,69,75\"]}]
*/

export default class LottoFavouritesMapperIn extends AbstractMapper<ILottoFavouritesDtoRaw, Favourites> {

    createTargetObject(dto: ILottoFavouritesDtoRaw): Favourites {
        if (dto === null) {
            return {};
        }
        try {
            const favouritesDto = JSON.parse(dto) as ILottoFavouritesDto;
            const favourites = {} as Favourites;
            favouritesDto.forEach(entry => {
                favourites[entry.k] = (entry.v.map(favs => this.parseFavoriteEntry(favs)).filter(Boolean)) as number[][];
            });
            return favourites as Favourites;
        } catch (e) {
            Logger.error(new Error('Parsing favourites object failed'));
            return {};
        }
    }

    private parseFavoriteEntry(entry: string) {
        try {
            return entry.split(',').map((num: string) => parseInt(num, 10));
        } catch (e) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/lotto/LottoFavouriteDtoToModelMapper.ts